import React from 'react';
import { Outlet } from 'react-router-dom';
import { AntdLayout, AntdRow, HEADER_HEIGHT, LAYOUT_HEIGHT, SAFE_AREA_HEIGHT, isYWC } from '@ui';
import { NavBar } from './NavBar';

const { Header, Content } = AntdLayout;

export interface LayoutProps {
  hideLinks?: boolean;
  navBar?: React.ReactNode;
}

export const Layout = ({ hideLinks }: LayoutProps) => {
  return (
    <AntdLayout>
      <Header
        className={`bg-white border-b border-base-200 border-solid border-x-0 border-t-0 ${
          isYWC ? 'h-24' : 'h-12'
        } px-4 sm:px-[78px] flex justify-between items-center`}
        style={{
          paddingTop: SAFE_AREA_HEIGHT,
          height: HEADER_HEIGHT,
        }}
      >
        <NavBar hideLinks={hideLinks} />
      </Header>

      <Content>
        <AntdRow
          className="bg-white px-4 sm:px-[78px] pt-[24px]"
          align={{ xs: 'stretch', sm: 'stretch', md: 'stretch', xl: 'stretch', xxl: 'stretch' }}
          style={{ height: LAYOUT_HEIGHT }}
          justify={'start'}
        >
          <div className="flex flex-col mx-auto w-full">
            <Outlet />
          </div>
        </AntdRow>
      </Content>
    </AntdLayout>
  );
};
